export const messages = {
  message: {
    login: {
      title: 'ลงชื่อเข้าใช้',
      header: 'ลงชื่อเข้าใช้บัญชีคลินิกของ ZeekDoc',
      user_placeholder: 'ชื่อผู้ใช้',
      password_placeholder: 'รหัสผ่าน',
      submit: 'ลงชื่อเข้าใช้',
      forgot_password: 'ลืมรหัสผ่าน?'
    },
    menu: {
      dashboard: 'แดชบอร์ด',
      appointment_pending: 'รอการยืนยัน',
      appointments: 'การนัดหมาย',
      patient: 'คนไข้',
      clinic_info: 'ข้อมูลคลินิก',
      clinic_information: 'ข้อมูลคลินิก',
      clinic_address: 'ที่่อยู่คลินิก',
      clinic_schedule: 'ตารางเวลาทำการ',
      clinic_services: 'บริการของคลินิก',
      clinic_settings: 'การตั้งค่า',
      clinic_leave: 'วันหยุดแพทย์',
      sms_broadcast: 'SMS broadcast',
      doctor: 'แพทย์',
      doctors: 'แพทย์',
      article: 'บทความ',
      feedback: 'ความคิดเห็น',
      report: 'รายงาน',
      clinic_view: 'ไปหน้าคลีนิก',
      doctor_view: 'ไปหน้าแพทย์',
      my_subcription: 'ดูแพลนสมาชิก',
      sign_out: 'ออกจากระบบ'
    },
    menu_message: {
      in_active_feature: 'ยังไม่ทำการเปิดใช้งาน'
    },
    clinic: {
      step_title: 'สร้างหน้าประวัติ',
      step_info: 'ข้อมูลคลินิก',
      step_address: 'วิธีการติดต่อ',
      step_schedule: 'ตารางเวลา',
      step_services: 'บริการของคลินิก',
      step_doctors: 'แพทย์ในคลินิก',
      create_clinic_success: 'หน้าประวิติของคุณได้ถูกสร้างแล้ว'
    },
    clinic_address: {
      title: 'วิธีการติดต่อ',
      address: 'ที่อยู่คลินิก',
      address_th: 'ที่อยู่คลินิกภาษาไทย',
      address_en: 'ที่อยู่คลินิกภาษาอังกฤษ',
      province: 'จังหวัด',
      district: 'อำเภอ',
      insurances: 'ประกันที่รับ',
      contact_info: 'ข้อมูลติดต่อคลินิก',
      email: 'อีเมล์',
      facebook: 'เฟซบุ๊ก',
      website: 'เว็บไซต์',
      clinic_map: 'แผนที่คลินิก',
      nearby_search: 'ค้นหาพื้นที่ใกล้เคียง'
    },
    pagination: {
      show: 'แสดง',
      from: 'จาก',
      prev: 'ก่อนหน้า',
      next: 'ถัดไป',
      rows: 'รายการ'
    },
    doctors: {
      title: 'แพทย์ในคลินิก',
      search_doctor: 'ค้นหาแพทย์',
      doctor_unit: 'แพทย์',
      no_doctor: 'ยังไม่มีแพทย์ในคลินิก',
      name_th: 'ชื่อภาษาไทย',
      name_en: 'ชื่อภาษาอังกฤษ',
      prefix: 'คำนำหน้า',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      specialty: 'สาขาเฉพาะทาง',
      specialty_placeholder: 'เลือกหรือพิมพ์ชื่อสาขาเฉพาะทาง',
      subspecialty: 'อนุสาขา',
      subspecialty_placeholder: 'เลือกอนุสาขาเฉพาะทาง',
      prefix_required: 'ต้องการคำนำหน้า',
      firstname_required: 'ต้องการชื่อ',
      lastname_required: 'ต้องการนามสกุล',
      specialty_required: 'ต้องการสาขาเฉพาะทาง',
      filter_specialty: 'สาขาเฉพาะทาง',
      filter_subspecialty: 'อนุสาขา',
      qr_code: 'QR'
    },
    clinic_info: {
      title: 'ข้อมูลคลินิก',
      clinic_name: 'ชื่อคลินิก',
      clinic_name_th: 'ชื่อคลินิกภาษาไทย',
      clinic_name_en: 'ชื่อคลินิกภาษาอังกฤษ',
      clinic_logo: 'โลโก้ของคลินิก',
      clinic_albums: 'อัลบั้มภาพของคลินิก',
      clinic_detail: 'รายละเอียดคลินิก',
      clinic_detail_th: 'รายละเอียดภาษาไทย',
      clinic_detail_en: 'รายละเอียดภาษาอังกฤษ',
      clinic_info: 'ข้อมูลคลินิก',
      clinic_info_th: 'ข้อมูลคลินิกภาษาไทย',
      clinic_info_en: 'ข้อมูลคลินิกภาษาอังกฤษ',
      clinic_info_placeholder_th: 'ข้อมูลต่างๆเกี่ยวกับคลินิก',
      clinic_info_placeholder_en: 'ข้อมูลต่างๆเกี่ยวกับคลินิก',
      clinic_picture_ph: 'เลือกรูปถ่ายของคุณ',
      video_links: 'วิดีโอที่เกี่ยวข้อง',
      youtube_link: 'Youtube Link'
    },
    schedules: {
      title: 'ตารางเวลา',
      schedule_for: 'ตารางออกตรวจของ',
      online_appointment_on: 'เปิดนัดหมายออนไลน์',
      select_time_slot: 'เลือกเวลาออกตรวจ',
      to: 'ถึง',
      add_time_slot: 'เพิ่มช่วงเวลาออกตรวจ',
      hide: 'ซ่อน',
      show: 'แสดง',
      options: 'ตัวเลือก',
      week: 'สัปดาห์ที่',
      last_week: 'สัปดาห์สุดท้ายของเดือน',
      monday: 'วันจันทร์',
      tuesday: 'วันอังคาร',
      wednesday: 'วันพุธ',
      thursday: 'วันพฤ',
      friday: 'วันศุกร์',
      saturday: 'วันเสาร์',
      sunday: 'วันอาทิตย์',
      select_time_slot_number: 'เลือก Slot เวลา',
      time_slot_e_g: 'ตัวอย่าง :หากเลือกระยะเวลาการตรวจเป็นเวลา 30 นาที ระบบจะแสดงผลเป็น 8.00, 8.30, 9.00, 9.30 เป็นต้น',
      example: 'ตัวอย่าง',
      booking_number: 'จองได้',
      booking_unit: 'คน',
      booking_number_per_time_slot: 'จำนวนคนไข้ใน 1 Slot เวลา',
      booking_number_per_time_slot_e_g: 'ตัวอย่าง :หากเลือก slot เวลา 30 นาที และจำนวนคนไข้ใน 1 slot เวลา 4 คน ระบบจะแสดงผลว่าคุณสามารถตรวจคนไข้ได้มากที่สุด 4 คนในเวลา 30 นาที'
    },
    services: {
      title: 'บริการของคลินิก',
      price: 'ราคา',
      price_from: 'ราคาเริ่มต้น',
      price_to: 'ราคาสูงสุด',
      price_range: 'แสดงราคาเป็นช่วง',
      no_services: 'ยังไม่มีบริการ',
      add_new_service: 'เพิ่มบริการของคลินิก',
      service_name_th: 'ชื่อบริการภาษาไทย',
      service_name_en: 'ชื่อบริการภาษาอังกฤษ',
      select_duration: 'เลือกระยะเวลา',
      service_duration: 'ระยะเวลาในการ',
      minutes: 'นาที',
      baht: 'บาท',
      service_detail: 'รายละเอียดบริการ',
      service_detail_th: 'รายละเอียดภาษาไทย',
      service_detail_en: 'รายละเอียดภาษาอังกฤษ',
      service_name_require: 'ต้องการชื่อ',
      service_duration_require: 'ต้องการระยะเวลา',
      service_price_require: 'ต้องการราคา'
    },
    settings: {
      title: 'การตั้งค่า',
      notification: 'การแจ้งเตือน',
      notify_when_appointment: 'แจ้งเตือนทาง SMS เมื่อ Admin สร้างนัดหมาย',
      new_appointment_fwd_to_mail: 'เมื่อมีนัดหมายแล้วให้ส่งไปที่ Email',
      email: 'Email',
      notify_sms: 'แจ้งเตือน SMS',
      notify_before_one_day: 'แจ้งเตือน 1 วันก่อนนัดหมาย',
      notify_appointment_day: 'แจ้งเตือนวันที่นัดหมาย ',
      notify_time: 'แจ้งคนไข้วันที่นัดหมายเวลา',
      credit_remain: 'จำนวน credit ที่เหลือ',
      auto_create_patient: 'บันทึกชื่อคนไข้อัตโนมัติ',
      feedback: 'ความคิดเห็น',
      show_feedback: 'แสดงความคิดเห็น',
      time: 'เวลา',
      search: 'การค้นหา',
      search_display: 'แสดงผลในหน้าการค้นหา'
    },
    leave: {
      title: 'วันหยุดแพทย์',
      date: 'วันที่',
      name: 'ชื่อแพทย์',
      remark: 'หมายเหตุ',
      no_leave: 'ไม่พบวันหยุด',
      title_add: 'เพิ่มวันหยุดแพทย์',
      title_edit: 'แก้ไขวันหยุดแพทย์',
      doctor: 'แพทย์',
      doctor_placeholder: 'เลือกแพทย์',
      leave_date: 'วันที่',
      to: 'ถึง',
      all_time: 'ทั้งวัน',
      leave_date_placeholder: 'เลือกช่วงวัน',
      leave_time_placeholder: 'เวลา',
      doctor_require: 'ต้องการข้อมูลแพทย์',
      time_require: 'ต้องการข้อมูลวันที่',
      time_invalid: 'วันที่ไม่ถูกต้อง',
      search_doctor: 'ค้นหาแพทย์',
      calendar: 'ปฏิทิน',
      list: 'รายการ'
    },
    article: {
      title: 'บทความ',
      search_article: 'ค้นหาบทความ',
      no_article: 'ไม่มีบทความ',
      title_article_add: 'เพิ่มบทความ',
      name: 'ชื่อบทความ',
      name_placeholder: 'ชื่อ',
      featured_image: 'รูปหัวข้อ',
      or_use_link: 'หรือ link ของภาพ',
      author: 'เขียนโดย',
      doctor: 'แพทย์',
      clinic: 'คลีนิก',
      status: 'สถานะ',
      unpublished: 'ยังไม่เผยแพร่',
      published: 'เผยแพร่',
      title_require: 'ต้องการข้อมูลชื่อ',
      content_require: 'ต้องการข้อมูลบทความ',
      select_featured_image: 'เลือกรูปของหัวข้อ',
      create_success: 'สร้างบทความสำเร็จ',
      update_success: 'บันทึกบทความสำเร็จ'
    },
    patient: {
      title: 'คนไข้',
      search_by: 'ค้นหาจากชื่อ, เลขประจำตัวประชาชน หรือเบอร์โทรศัพท์',
      patient_list: 'รายชื่อคนไข้',
      no_patient: 'ไม่มีรายการคนไข้',
      required_info: 'ข้อมูลที่จำเป็น',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      phone_no: 'เบอร์มือถือ',
      contact: 'ข้อมูลสำหรับติดต่อ',
      email: 'อีเมล',
      address: 'ที่อยู่',
      personal_info: 'ข้อมูลส่วนตัว',
      id_card: 'เลขประจำตัวประชาชนหรือเลขหนังสือเดินทาง',
      birthdate: 'วันเกิด',
      allergy: 'ประวัติการแพ้ยา',
      diseases: 'โรคประจำตัว',
      relative_info: 'ข้อมูลญาติกรณีฉุกเฉิน',
      relative_name: 'ชื่อญาติ',
      relative_relation: 'ความสัมพันธ์',
      relative_phone: 'เบอร์โทรศัพท์ของญาติ',
      create_success: 'บันทึกคนไข้สำเร็จ',
      firstname_require: 'ต้องการชื่อ',
      lastname_require: 'ต้องการนามสกุล',
      phone_require: 'ต้องการเบอร์',
      birthday_require: 'ต้องการวันเกิด',
      prefix: 'คำนำหน้า',
      prefix_placeholder: 'คำนำหน้า',
      prefix_mrs: 'นาง',
      prefix_mr: 'นาย',
      prefix_ms: 'นางสาว',
      prefix_master: 'ด.ช.',
      prefix_miss: 'ด.ญ.',
      hn: 'HN'
    },
    report: {
      title: 'สถิติ',
      view_and_appointment: 'จำนวนผู้เยี่ยมชมและนัดหมาย',
      visitor_detail: 'ลักษณะผู้เยี่ยมชม',
      male: 'ชาย',
      female: 'หญิง',
      article: 'บทความ',
      popular_article: 'บทความที่ได้รับความนิยม',
      article_visitor: 'ผู้เยี่ยมชม',
      article_appointment: 'นัดหมาย',
      no_article: 'ไม่พบบทความ',
      popular_doctor: 'หมอที่ได้รับความนิยม',
      doctor_rank: 'อันดับ',
      doctor_name: 'ชื่อหมอ',
      doctor_appointment_count: 'นัดหมาย',
      today: 'วันนี้',
      week: 'สัปดาห์นี้',
      month: 'เดือนนี้',
      year: 'ปีนี้',
      status_summary: 'สรุปสถานะนัดหมาย',
      status_pending: 'รอการยืนยัน',
      status_checkin: 'เช็คอิิน',
      status_cancel: 'ยกเลิก',
      status_scheduled: 'นัดหมาย'
    },
    dashboard: {
      title: 'หน้าแรก',
      notification: 'แจ้งเตือน',
      appointment_m: 'จำนวนนัดหมายย้อนหลัง 30 วัน',
      appointment: 'นัดหมาย',
      view_all_appointment: 'ดูนัดหมายวันนี้ทั้งหมด',
      visitor_m: 'จำนวนผู้เยี่ยมชมย้อนหลัง 30 วัน',
      visitor: 'ผู้เยี่ยมชม',
      view_all_visitor: 'ดูสถิติทั้งหมด',
      notification_appointment_first: 'มีนัดหมายใหม่ที่รอการยืนยัน <strong>',
      notification_appointment_last: ' นัดหมาย</strong> กรุณายืนยันนัดหมาย',
      notification_action: 'ดูนัดหมาย'
    },
    doctor_header: {
      title_new: 'สร้างประวัติ',
      title_edit: 'แก้ไขประวัติ',
      personal_info: 'ข้อมูลส่วนตัว',
      experience: 'การทำงาน',
      schedules: 'ตารางออกตรวจ',
      education: 'การศึกษา',
      other_info: 'ข้อมูลอื่นๆ'
    },
    doctor_general: {
      name_th: 'ชื่อภาษาไทย',
      prefix: 'คำนำหน้า',
      prefix_placeholder_th: 'นพ., พญ.',
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      name_en: 'ชื่อภาษาอังกฤษ',
      prefix_placeholder_en: 'Dr..',
      gender: 'เพศ',
      male: 'ชาย',
      female: 'หญิง',
      image: 'รูปถ่ายของคุณ',
      select_image: 'เลือกรูปถ่ายของคุณ',
      albums: 'อัลบั้มของคุณ'
    },
    doctor_experience: {
      specialty: 'สาขาเฉพาะทาง',
      specialty_placeholder: 'เลือกหรือพิมพ์ชื่อสาขาเฉพาะทาง',
      subspecialty: 'อนุสาขาเฉพาะทาง',
      subspecialty_placeholder: 'เลือกอนุสาขาเฉพาะทาง',
      medical_procedure_th: 'หัตถการภาษาไทย',
      medical_procedure_en: 'หัตถการภาษาอังกฤษ',
      medical_procedure_placeholder: 'กรุณาใส่หัตถการที่เชี่ยวชาญ 3 อันดับแรก เช่น จัดฟัน ฟันปลอม ใส่ฟัน',
      place: 'สถานพยาบาลที่ทำงานอยู่',
      clinic_place: 'สถานพยาบาลเอกชน',
      clinic_place_placeholder: 'เลือกหรือพิมพ์ชื่อสถานพยาบาลเอกชน',
      institute_place: 'สถานพยาบาลภาครัฐ',
      institute_place_placeholder: 'เลือกสถานพยาบาลภาครัฐ'
    },
    doctor_education: {
      education_info: 'ข้อมูลการศึกษา',
      education_info_th: 'ข้อมูลการศึกษา (ภาษาไทย)',
      education_info_en: 'ข้อมูลการศึกษา (ภาษาอังกฤษ)',
      certifications: 'วุฒิบัตร',
      certifications_th: 'ชื่อวุฒิบัตร (ภาษาไทย)',
      certifications_en: 'ชื่อวุฒิบัตร (ภาษาอังกฤษ)',
      license_number: 'เลขที่ใบประกอบวิชาชีพ',
      professional_memberships: 'สมาชิกสมาคมแพทย์',
      professional_memberships_th: 'ชื่อสมาคมแพทย์ (ภาษาไทย)',
      professional_memberships_en: 'ชื่อสมาคมแพทย์ (ภาษาอังกฤษ)'
    },
    doctor_schedules: {
      schedule: 'ตารางออกตรวจ',
      online_appointment_on: 'เปิดนัดหมายออนไลน์',
      select_time_slot_for: 'เลือกเวลาออกตรวจสำหรับที่'
    },
    doctor_info: {
      language: 'ภาษา',
      language_placeholder: 'เลือกหรือพิมพ์ภาษาได้มากกว่า 1',
      video_links: 'วิดีโอที่เกี่ยวข้อง',
      youtube_link: 'Youtube Link',
      addition_info: 'ข้อมูลเพิ่มเติม',
      addition_info_th: 'ข้อมูลเพิ่มเติม (ภาษาไทย)',
      addition_info_en: 'ข้อมูลเพิ่มเติม (อังกฤษ)',
      save_success: 'ได้บันทึกหน้าประวิติของคุณแล้ว',
      create_success: 'หน้าประวิติของคุณได้ถูกสร้างแล้ว'
    },
    alert_bar: {
      title: 'กรุณากรอกข้อมูลให้ครบ',
      message: 'แอดเคาท์ของท่านจะได้รับการ active เมื่อข้อมูลถูกต้องครบถ้วน ติดต่อ สอบถามเพิ่มเติม',
      contact: 'ได้ที่ 092-462-6633 (คุณ ฟ้า)'
    },
    alert_bar_payment: {
      message: 'ข้อมูลของท่านยังไม่อยู่ในหน้าค้นหา ต้องการเปิดการค้นหากรุณา ไปที่',
      contact: 'ได้ที่ 092-462-6633 (คุณ ฟ้า)'
    },
    alert_bar_sms_warning: {
      title: 'Sms credit ของท่านใกล้หมดแล้ว',
      message: 'sms credit ในแอดเคาท์ของท่าน เหลืออยู่',
      contact: 'ติดต่อเติม credit ได้ที่ 092-462-6633 (คุณ ฟ้า)'
    },
    drop_zone: {
      place_holder: 'ลากไฟล์ลงมาตรงนี้<br> หรือกดเพื่อเลือกไฟล์'
    },
    appointment: {
      title_edit: 'แก้ไขรายการนัดหมาย',
      title_add: 'เพิ่มรายการนัดหมาย',
      status_scheduled: 'Scheduled',
      status_cancel: 'ยกเลิกนัดหมาย',
      status_checkin: 'Check-In',
      status_patient_confirm: 'คนไข้ยืนยัน',
      status_patient_confirm_3hr: 'คนไข้ยืนยัน (3 ชั่วโมง)',
      label_date_time_appointment: 'วัน เวลา ที่นัดหมาย',
      doctor: 'แพทย์',
      doctor_placeholder: 'เลือกแพทย์',
      search_patient_placeholder: 'ค้นหาคนไข้ด้วย ชื่อ, นามสกุล, อีเมล, เบอร์โทรศัพท์, HN',
      prefix: 'คำนำหน้า',
      prefix_placeholder: 'คำนำหน้า',
      firstname: 'ชื่อ',
      firstname_placeholder: 'ชื่อ',
      lastname: 'นามสกุล',
      lastname_placeholder: 'นามสกุล',
      phone: 'เบอร์มือถือ',
      email: 'อีเมล',
      email_placeholder: 'อีเมล',
      seen_doctor: 'เคยพบแพทย์',
      have: 'เคย',
      have_not: 'ไม่เคย',
      medical_record: 'มีประวัติ',
      have_yes: 'มี',
      have_no: 'ไม่มี',
      booking_for: 'เพื่อ',
      myself: 'ตัวเอง',
      another: 'คนอื่น',
      id_card: 'หมายเลขบัตรประชาชนหรือหมายเลขหนังสือเดินทาง',
      birthdate: 'วันเกิด',
      service: 'บริการ',
      service_placeholder: 'เลือกบริการ',
      duration: 'ระยะเวลา',
      duration_placeholder: 'เลือกระยะเวลา',
      duration_unit: 'นาที',
      addition: 'คนไข้เล่าอาการ',
      addition_placeholder: 'คนไข้เล่าอาการ',
      remark: 'อีเมล/SMS หมายเหตุ',
      remark_placeholder: 'สำหรับแจ้งเตือนคนไข้ เช่น กรุณางดยาละลายลิ่มเลือดก่อนล่วงหน้า 7 วัน',
      admin_remark: 'สำหรับเจ้าหน้าที่',
      admin_remark_placeholder: 'หมายเหตุ',
      are_you_wath_to_cancel: 'ต้องการที่จะยกเลิกนัดหมายนี้ ?',
      cancel_appointment_success: 'ยกเลิกนัดหมายสำเร็จ',
      firstname_require: 'ต้องการข้อมูลชื่อ',
      lastname_require: 'ต้องการข้อมูลนามสกุล',
      phone_require: 'ต้องการข้อมูลหมายเลขโทรศัพท์',
      email_require: 'ต้องการข้อมูลอีเมล',
      doctor_require: 'ต้องการข้อมูลแพทย์',
      prefix_mrs: 'นาง',
      prefix_mr: 'นาย',
      prefix_ms: 'นางสาว',
      prefix_master: 'ด.ช.',
      prefix_miss: 'ด.ญ.',
      pending_view: 'รอการยืนยัน',
      appointment_view: 'การนัดหมาย',
      search_appointment: 'ค้นหาการนัดหมายจากชื่อ เลขบัตรประชาชน เบอร์โทรศัพท์',
      no_appointment: 'ไม่มีการนัดหมาย',
      add_appointment: 'เพิ่มรายการนัดหมาย',
      appointment_date: 'วันที่นัดหมาย',
      title_appointmemt: 'การนัดหมาย',
      daily_view: 'รายวัน',
      weekly_view: 'รายสัปดาห์',
      monthly_view: 'รายเดือน',
      list_view: 'รายชื่อ',
      filter_date_all: 'ทั้งหมด',
      filter_date_range: 'เลือกตามวัน',
      filter_date_range_placeholder: 'เลือกช่วงเวลา',
      filter_specialty: 'สาขาเฉพาะทาง',
      filter_doctor: 'แพทย์',
      filter_clinic: 'คลินิก',
      filter_status: 'สถานะ',
      filter_service: 'บริการ',
      filter_hn: 'HN',
      filter_search: 'ค้นหาจากชื่อคนไข้, เบอร์โทร, HN หรือ ID card',
      order: 'หมายเลข',
      date: 'วันนัดหมาย',
      patient: 'ชื่อคนไข้',
      doctor_name: 'ชื่อแพทย์',
      service_name: 'บริการ',
      patient_status: 'คนไข้ยืนยัน',
      appointment_status: 'สถานะนัดหมาย',
      no_appointment_with_filter: 'ไม่พบการนัดหมายภายในเงื่อนไขที่กำหนด',
      new_patient: 'คนไข้ใหม่',
      old_patient: 'คนไข้เก่าในระบบ',
      view_more: 'ดูรายละเอียดเพิ่มเติม',
      cancel_appointment: 'ยกเลิกนัดหมาย',
      doctor_list: 'รายชื่อแพทย์',
      confirm_status: 'ยืนยัน',
      not_confirm_status: 'ไม่ยืนยัน',
      latest_reminded_time: 'แจ้งเตือนล่าสุด',
      locale: 'ภาษา',
      locale_placeholder: 'ภาษา',
      hn: 'HN',
      export_appointments: 'บันทึกเป็นไฟล์'
    },
    feedback: {
      title: 'ความคิดเห็น',
      appointment_no: 'หมายเลขนัดหมาย',
      appointment_date: 'วันนัดหมาย',
      patient_name: 'ชื่อคนไข้',
      doctor_name: 'ชื่อแพทย์',
      score: 'คะแนน',
      comment: 'ความคิดเห็น',
      no_comment: 'ไม่พบความคิดเห็น'
    },
    remarks: {
      title_remark_editor: 'แก้ไขเทมเพลต',
      name: 'ชื่อ',
      remark: 'ข้อความ'
    }
  },
  action_message: {
    cancel: 'ยกเลิก',
    ok: 'ตกลง',
    save: 'บันทึก',
    back: 'ย้อนกลับ',
    edit: 'แก้ไข',
    add: 'เพิ่ม',
    remove: 'ลบ',
    list: 'รายการ',
    view: 'แสดง',
    are_you_sure: 'คุณแน่ใจแล้วใช่ไหม?',
    close: 'ปิด',
    view_more: 'ดูเพิ่มเติม',
    save_success: 'บันทึกแล้ว',
    save_not_success: 'บันทึกไม่สำเร็จ',
    download_qr_code: 'โหลด QR Code'
  }
}



// WEBPACK FOOTER //
// ./src/lang/localization-th.js